import { graphql } from "gql";

const GET_ORGANIZATION_ID = graphql(`
  query GetOrganizationId($organizationName: String!) {
    organizationId(organizationName: $organizationName) {
      id
      name
    }
  }
`);

const GET_ORGANIZATION_DATA = graphql(`
  query GetOrganizationData(
    $canGetGroups: Boolean!
    $organizationName: String!
  ) {
    me {
      userEmail
      tags(organizationName: $organizationName) {
        name
        groups @include(if: $canGetGroups) {
          name
        }
      }
    }
    organizationId(organizationName: $organizationName) {
      id
      hasZtnaRoots
      name
      permissions
    }
  }
`);

const GET_ORGANIZATION_GROUPS_FINDINGS = graphql(`
  query GetOrganizationGroupsFindings(
    $after: String
    $first: Int!
    $organizationId: String!
  ) {
    organization(organizationId: $organizationId) {
      name
      slsaF05: analytics(documentName: "slsaF05", documentType: "textBox")
      slsaF2: analytics(documentName: "slsaF2", documentType: "textBox")
      groupsConnection(after: $after, first: $first) {
        edges {
          node {
            hasAdvanced
            name
            findings {
              id
              title
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`);

export {
  GET_ORGANIZATION_DATA,
  GET_ORGANIZATION_ID,
  GET_ORGANIZATION_GROUPS_FINDINGS,
};
